import PageDashboard from './PageDashboard'

export default PageDashboard
